<template>
    <div>
        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-4">
                    <stats-card title="Total Number of Loan Applications"
                                type="gradient-red"
                                :sub-title=formatNumber(summary.number_of_loan_applications)
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                                >
                    
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-4">
                    <stats-card title="Total Number of Approved Loans"
                                type="gradient-orange"
                                :sub-title=formatNumber(summary.number_of_loans)
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-4">
                    <stats-card title="Number of Registered Members"
                                type="gradient-success"
                                :sub-title=formatNumber(summary.number_of_members)
                                icon="ni ni-circle-08"
                                class="mb-4 mb-xl-0"
                                >
                    
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-4">
                    <stats-card title="Total Number of Available Users"
                                type="gradient-info"
                                :sub-title=formatNumber(summary.number_of_users)
                                icon="ni ni-single-02"
                                class="mb-4 mb-xl-0"
                    >

                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-4">
                    <stats-card title="Total Loan Application Amount"
                                type="gradient-orange"
                                :sub-title=formatCost(summary.total_application)
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                                >
                    
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-4">
                    <stats-card title="Total Loan Approved Amount"
                                type="gradient-info"
                                :sub-title=formatCost(summary.total_approved_amount)
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-4">
                    <stats-card title="Total Loan Amount Repayment"
                                type="gradient-success"
                                :sub-title=formatCost(summary.total_loan_repayment)
                                icon="ni ni-credit-card"
                                class="mb-4 mb-xl-0"
                                >
                    
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-4">
                    <stats-card title="Total Loan Pending Amount"
                                type="gradient-red"
                                :sub-title=formatCost(summary.total_loan_balance)
                                icon="ni ni-credit-card"
                                class="mb-4 mb-xl-0"
                    >

                    </stats-card>
                </div>>
            </div>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <!-- <div class="row">
                <div class="col-xl-8 mb-5 mb-xl-0">
                    <card type="default" header-classes="bg-transparent">
                        <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h6 class="text-light text-uppercase ls-1 mb-1">Overview</h6>
                                <h5 class="h3 text-white mb-0">Sales value</h5>
                            </div>
                            <div class="col">
                                <ul class="nav nav-pills justify-content-end">
                                    <li class="nav-item mr-2 mr-md-0">
                                        <a class="nav-link py-2 px-3"
                                           href="#"
                                           :class="{active: bigLineChart.activeIndex === 0}"
                                           @click.prevent="initBigChart(0)">
                                            <span class="d-none d-md-block">Month</span>
                                            <span class="d-md-none">M</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link py-2 px-3"
                                           href="#"
                                           :class="{active: bigLineChart.activeIndex === 1}"
                                           @click.prevent="initBigChart(1)">
                                            <span class="d-none d-md-block">Week</span>
                                            <span class="d-md-none">W</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <line-chart
                                :height="350"
                                ref="bigChart"
                                :chart-data="bigLineChart.chartData"
                                :extra-options="bigLineChart.extraOptions"
                        >
                        </line-chart>

                    </card>
                </div>

                <div class="col-xl-4">
                    <card header-classes="bg-transparent">
                        <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h6 class="text-uppercase text-muted ls-1 mb-1">Performance</h6>
                                <h5 class="h3 mb-0">Total orders</h5>
                            </div>
                        </div>

                        <bar-chart
                                :height="350"
                                ref="barChart"
                                :chart-data="redBarChart.chartData"
                        >
                        </bar-chart>
                    </card>
                </div>
            </div> -->
            <!-- End charts-->

            <!--Tables-->
            <!-- <div class="row mt-5">
                <div class="col-xl-8 mb-5 mb-xl-0">
                    <page-visits-table></page-visits-table>
                </div>
                <div class="col-xl-4">
                    <social-traffic-table></social-traffic-table>
                </div>
            </div> -->
            <!--End tables-->
        </div>
    </div>
</template>
<script>
  // Charts
  import * as chartConfigs from '@/components/Charts/config';
  import LineChart from '@/components/Charts/LineChart';
  import BarChart from '@/components/Charts/BarChart';

  // // Tables
  // import SocialTrafficTable from '../Dashboard/SocialTrafficTable';
  // import PageVisitsTable from '../Dashboard/PageVisitsTable';

  export default {
    components: {
      LineChart,
      BarChart,
      // PageVisitsTable,
      // SocialTrafficTable,
    },
    data() {
      return {
        bigLineChart: {
          allData: [
            [0, 20, 10, 30, 15, 40, 20, 60, 60],
            [0, 20, 5, 25, 10, 30, 15, 40, 40]
          ],
          activeIndex: 0,
          chartData: {
            datasets: [],
            labels: [],
          },
          extraOptions: chartConfigs.blueChartOptions,
        },
        redBarChart: {
          chartData: {
            labels: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            datasets: [{
              label: 'Sales',
              data: [25, 20, 30, 22, 17, 29]
            }]
          }
        }
      };
    },
    methods: {
       formatCost(amount) {
                const result = Number(amount).toLocaleString()
                if (result !== 0) {
                    return `Ksh. ${result}`;
                } else {
                    return '0';
                }
            },
             formatNumber(amount) {
                const result = Number(amount).toLocaleString()
                if (result !== 0) {
                    return result;
                } else {
                    return '0';
                }
            },
      initBigChart(index) {
        let chartData = {
          datasets: [
            {
              label: 'Performance',
              data: this.bigLineChart.allData[index]
            }
          ],
          labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        };
        this.bigLineChart.chartData = chartData;
        this.bigLineChart.activeIndex = index;
      }
    },
    created(){
      const userPublicId = localStorage.getItem('pdis');
      this.$store.dispatch('notifications_function', userPublicId);
      this.$store.dispatch('summary_function');
      
      
    },
    mounted() {
      this.initBigChart(0);
    }
  };
</script>
<style></style>
